import {Dropdown, Form} from "semantic-ui-react";
import React from "react";

export default function NewContractForm(props: {
    contractValidated: boolean,
    formData: any,
    setFormData: any,
    clients: any,
    flowledgerUser: any,
}): React.JSX.Element {
  const { contractValidated, formData, setFormData, clients, flowledgerUser } = props;
  return (
      <Form className="flex-1">
          <Form.Field>
              <label>Contract Name</label>
              <Form.Input
                  type="text"
                  disabled={contractValidated}
                  placeholder="Contract Name"
                  onChange={(_, { value }) => {
                      setFormData({
                          ...formData,
                          contractName: value,
                      });
                  }}
              />
          </Form.Field>
          <Form.Field>
              <label>Contract Reference</label>
              <Form.Input
                  type="text"
                  disabled={contractValidated}
                  placeholder="Contract Reference"
                  onChange={(_, { value }) => {
                      setFormData({
                          ...formData,
                          contractReference: value,
                      });
                  }}
              />
          </Form.Field>
          <Form.Field>
              <label>Contract Type</label>
              <Form.Dropdown
                  placeholder="Select Contract Type"
                  disabled={contractValidated}
                  fluid
                  search
                  selection
                  onChange={(_, { value }) => {
                      setFormData({
                          ...formData,
                          contractType: value,
                      });
                  }}
                  options={[{
                      key: 1,
                      text: "NEC ECC Option A - Priced contract with activity schedule",
                      value: "NEC ECC Option A - Priced contract with activity schedule"
                  },
                      {
                          key: 2,
                          text: "NEC ECC Option B - Priced contract with bill of quantities",
                          value: "NEC ECC Option B - Priced contract with bill of quantities"
                      },
                      {
                          key: 3,
                          text: "NEC ECC Option C - Target contract with activity schedule",
                          value: "NEC ECC Option C - Target contract with activity schedule"
                      },
                      {
                          key: 4,
                          text: "NEC ECC Option D - Target contract with bill of quantities",
                          value: "NEC ECC Option D - Target contract with bill of quantities"
                      },
                      {
                          key: 5,
                          text: "NEC ECC Option E - Cost reimbursable contract",
                          value: "NEC ECC Option E - Cost reimbursable contract"
                      },
                      {
                          key: 6,
                          text: "NEC ECC Option F - Management contract",
                          value: "NEC ECC Option F - Management contract"
                      },
                      {
                          key: 7,
                          text: "NEC PSC Option A - Priced contract with activity schedule",
                          value: "NEC PSC Option A - Priced contract with activity schedule"
                      },
                      {
                          key: 9,
                          text: "NEC PSC Option C - Target contract with activity schedule",
                          value: "NEC PSC Option C - Target contract with activity schedule"
                      },
                      {
                          key: 11,
                          text: "NEC PSC Option E - Cost reimbursable contract",
                          value: "NEC PSC Option E - Cost reimbursable contract"
                      },
                      {
                          key: 13,
                          text: "JCT Design and Build",
                          value: "JCT Design and Build"
                      },
                      {
                          key: 14,
                          text: "JCT Standard Building Contract",
                          value: "JCT Standard Building Contract"
                      },
                      {
                          key: 15,
                          text: "PPC 2000",
                          value: "PPC 2000"
                      },
                      {
                          key: 16,
                          text: "FIDIC Red Book",
                          value: "FIDIC Red Book"
                      },
                      {
                          key: 17,
                          text: "FIDIC Yellow Book",
                          value: "FIDIC Yellow Book"
                      },
                      {
                          key: 18,
                          text: "FIDIC Silver Book",
                          value: "FIDIC Silver Book"
                      },
                      {
                          key: 19,
                          text: "FIDIC Gold Book",
                          value: "FIDIC Gold Book"
                      },
                      {
                          key: 20,
                          text: "IChemE Red Book",
                          value: "IChemE Red Book"
                      },
                      {
                          key: 21,
                          text: "IChemE Green Book",
                          value: "IChemE Green Book"
                      },
                      {
                          key: 22,
                          text: "IChemE Burgundy Book",
                          value: "IChemE Burgundy Book"
                      },
                      {
                          key: 25,
                          text: "ICE Design and Construct Contract",
                          value: "ICE Design and Construct Contract"
                      },
                      {
                          key: 26,
                          text: "Bespoke Contract",
                          value: "Bespoke Contract"
                      }
                  ]}/>
          </Form.Field>
          <Form.Field>
              <label>Approximate Contract Value (£,000 - optional)</label>
              <Form.Input
                  type="number"
                  disabled={contractValidated}
                  placeholder="Contract Value (£,000 - optional)"
                  value={formData.contractValue === 0 ? "" : formData.contractValue}
                  onChange={(_, { value }) => {
                      setFormData({
                          ...formData,
                          contractValue: value,
                      });
                  }}
                  min={0}
                  step={1000} />
          </Form.Field>
          {flowledgerUser && <Form.Field>
              <label>Client</label>
              <Form.Dropdown
                  placeholder="Select Client"
                  fluid
                  search
                  selection
                  disabled={contractValidated}
                  value={formData.clientId}
                  onChange={(_, { value }) => {
                      setFormData({
                          ...formData,
                          clientId: value,
                      });
                  }}
                  options={clients}/>
          </Form.Field>}
          <span style={{display: 'grid', gridTemplateColumns: '65% 35%', gap: '5px'}}>
                    <Form.Field>
                        <label>Sprint Start Day</label>
                        <Dropdown
                            placeholder="Sprint Start Day"
                            fluid
                            selection
                            disabled={contractValidated}
                            value={formData.sprintStartDay}
                            onChange={(_, { value }) => {
                                setFormData({
                                    ...formData,
                                    sprintStartDay: value,
                                });
                            }}
                            options={[
                                {key: 1, text: "Monday", value: 1 },
                                {key: 2, text: "Tuesday", value: 2 },
                                {key: 3, text: "Wednesday", value: 3 },
                                {key: 4, text: "Thursday", value: 4 },
                                {key: 5, text: "Friday", value: 5 },
                                {key: 6, text: "Saturday", value: 6 },
                                {key: 7, text: "Sunday", value: 7 },
                            ]}/>
                    </Form.Field>
                    <Form.Field>
                            <label>Sprint Lock Time</label>
                        <Dropdown
                            placeholder="Sprint Lock Time"
                            fluid
                            selection
                            disabled={contractValidated}
                            value={formData.sprintLockTime}
                            onChange={(_, { value }) => {
                                setFormData({
                                    ...formData,
                                    sprintLockTime: value,
                                });
                            }}
                            options={Array.from({length: 24}, (_, i) => ({
                                key: i,
                                text: `${i.toString().padStart(2, '0')}:00`,
                                value: i
                            }))}/>
                    </Form.Field>
                </span>
      </Form>
  );
}